import { googleMapsMapping } from './google-json-structure.js';

function initMappings() {
	const mappingModules = import.meta.glob( './mappings/*.js', {
		eager: true,
	} );
	const mappings = {};
	for ( const [ path, mod ] of Object.entries( mappingModules ) ) {
		const key = path.match( /\/([\w-]+)\.js$/ )[ 1 ];
		mappings[ key ] = mod.default;
	}
	return mappings;
}

export function getApiName( googleKey, sourceType, opts = {} ) {
	const mappings = initMappings();
	if ( ! googleKey || ! sourceType || ! mappings[ sourceType ] ) return null;
	const mapping = mappings[ sourceType ];
	const mapObj = mapping[ googleKey ];
	if ( ! mapObj ) return null;
	if ( opts.returnParser ) return mapObj.parser;

	return mapObj.apiName;
}

export function makeBackwardsCompatibleMap( sourceObj, sourceType ) {
	const mappings = initMappings();
	if ( ! sourceObj || ! sourceType || ! mappings[ sourceType ] ) return null;
	const mapping = mappings[ sourceType ];
	const result = {};
	Object.keys( googleMapsMapping ).forEach( ( key ) => {
		const mapObj = mapping[ key ];
		if ( ! mapObj ) {
			result[ key ] = '';
			return;
		}
		if ( typeof mapObj.parser === 'function' ) {
			result[ key ] = mapObj.parser( sourceObj );
		} else if ( typeof mapObj.parser !== 'undefined' ) {
			result[ key ] = mapObj.parser;
		} else if ( typeof mapObj.apiName === 'string' ) {
			result[ key ] = sourceObj[ mapObj.apiName ] || '';
		} else {
			result[ key ] = '';
		}
	} );
	return result;
}
